import { useTranslation } from '../../../../../app/_providers/TranslationProvider.client'
import { MAX_TEXT_ITEMS } from '../../../../../containers/EmbroideryContainer/combination-rules/flows/dtcEmbroidery'
import { EmbroideryTypeKey } from '../../../../../containers/EmbroideryContainer/combination-rules/types'
import { IconPlacementEditor } from '../../parts/icon/IconPlacementEditor/IconPlacementEditor'
import { LogoPlacementEditor } from '../../parts/logo/LogoPlacementEditor/LogoPlacementEditor'
import { EmbroideryOptionRows } from '../../parts/PanelOptions/EmbroideryOptionRows'
import { GarmentOptionRows } from '../../parts/PanelOptions/GarmentOptionRows'
import { OptionRowList } from '../../parts/PanelOptions/styles'
import { TextPlacementEditor } from '../../parts/text/TextPlacementEditor/TextPlacementEditor'
import { PanelBody } from '../../styles'

import { Intro, SubTitle, Title } from './styles'

export type DtcOptionsPanelProps = {
  /** Which editor is on top of the option list. See `useDtcSectionNavigation`. */
  openTypeKey: EmbroideryTypeKey | null
  onOpenType(typeKey: EmbroideryTypeKey): void
  onCloseType(): void
  /** The buttons under the option list. Hidden while an editor is open. */
  footer: React.ReactNode
}

/**
 * The options side of the DTC modal: the list of things the customer can personalize, with one
 * type's editor stacked over it while the customer is in one.
 */
export const DtcOptionsPanel: React.FC<DtcOptionsPanelProps> = ({
  openTypeKey,
  onOpenType,
  onCloseType,
  footer,
}) => {
  const {
    embroidery: {
      modal: { previewTitle, previewSubtitle },
    },
  } = useTranslation()

  if (openTypeKey === 'text')
    return (
      <TextPlacementEditor
        maxPlacements={MAX_TEXT_ITEMS}
        onDone={onCloseType}
        onBack={onCloseType}
      />
    )
  if (openTypeKey === 'icon')
    return <IconPlacementEditor onDone={onCloseType} onBack={onCloseType} />
  if (openTypeKey === 'logo')
    return <LogoPlacementEditor onDone={onCloseType} onBack={onCloseType} />

  return (
    <>
      <PanelBody>
        <Intro>
          <Title>{previewTitle}</Title>
          <SubTitle>{previewSubtitle}</SubTitle>
        </Intro>

        <OptionRowList>
          <GarmentOptionRows />
          <EmbroideryOptionRows onOpenType={onOpenType} />
        </OptionRowList>
      </PanelBody>

      {footer}
    </>
  )
}
